export const awsS3Url = 'https://assets-prd.digitalfemsa.io/cpanel/statics/assets';
export const awsS3CheckoutUrl = 'https://assets-prd.digitalfemsa.io/checkout/img';
export const favicon = `${awsS3CheckoutUrl}/logos/favicon.ico`;
export const imgMainLogoFullBlue = `${awsS3Url}/img/logoOxxo.png`;
export const imgMainLogoWhite = `${awsS3Url}/img/logo_oxxo_white.png`;
export const imgLogoWhite = `${awsS3Url}/img/LogoOXXOPAYBySpinWhite.png`;
export const imgPaymentButtonLogoConekta = `${awsS3Url}/img/conekta-logo-symbol.svg`;
export const imgPaymentButtonLogoConektaWhite = `${awsS3Url}/img/conekta-logo-symbol-inverse.svg`;
export const whatsappImage = `${awsS3Url}/img/icons/whatsapp.svg`;

export const firstImgBackgroundAmount = `${awsS3Url}/img/bg-esfera.svg`;
export const secondImgBackgroundAmount = `${awsS3Url}/img/bg-media-esfera.svg`;
export const disabledOpenAmountImg = `${awsS3Url}/img/Ilustraciones/empty-box.svg`;

export const imgPadlock = `${awsS3Url}/img/https_black_24dp-%201.svg`;

export const imgError404 = `${awsS3Url}/img/link/icon_404.svg`;
export const imgTimeOut = `${awsS3Url}/img/time.svg`;
export const imgTime = `${awsS3Url}/img/link/time.svg`;
export const imgIconError = `${awsS3Url}/img/link/icon_error.svg`;
export const imgBill = `${awsS3Url}/img/link/bill.svg`;
export const imgIconCancelled = `${awsS3Url}/img/link/icon_cancelled.svg`;
export const imgShoppingCart = `${awsS3Url}/img/icons/white-shopping-cart-24px.svg`;

export const paymentBrandLogos = {
  oxxo: `${awsS3Url}/brands/logos/OXXO_PAY_logo.svg`,
  oxxo_img: `${awsS3Url}/img/oxxo-pay-2019.svg`,
};

export const paymentBrands: Record<string, any> = {
  oxxo: {
    alt: 'Oxxo',
    className: 'oxxo',
    src: paymentBrandLogos.oxxo_img,
  },
  oxxo_cash: {
    alt: 'Oxxo',
    className: 'oxxo_cash',
    src: paymentBrandLogos.oxxo_img,
  },
  oxxo_recurrente: {
    alt: 'Oxxo',
    className: 'oxxo_recurrente',
    src: paymentBrandLogos.oxxo_img,
  },
};

export enum PaymentMethodType {
  Cash = 'Cash',
}

export enum PaymentMethodSelect {
  Cash = 'cash',
}

export const checkoutRequestType = {
  hostedPayment: 'HostedPayment',
  integration: 'Integration',
  paymentLink: 'PaymentLink',
};

export enum PaymentConfirmationShareIcons {
  Mail = 'email',
  Whatsapp = 'whatsapp',
  Several = 'share',
  ContentCopy = 'content_copy',
  Check = 'check',
  Close = 'close',
}

export enum PaymentConfirmationShareWhatsAppUris {
  Desktop = 'https://api.whatsapp.com/send/?text=',
  Mobile = 'whatsapp://send?text=',
}

export enum AnalyticEvents {
  paymentMethodsMenu = 'payment_methods_menu',
  paymentMethodCash = 'Cash',
  successPage = 'success_page',
  shipmentInfo = 'shipment_info',
  shareEmail = 'share_email',

  checkoutDetail = 'checkout_detail',
  changePaymentMethod = 'change_payment_method',
  paymentButton = 'payment_button',
  langSelection = 'lang_selection',
  helpCenter = 'help_center',
  nextStep = 'next_step',
  termsAndConditions = 'terms_and_conditions',

  name = 'customer_info.name',
  email = 'customer_info.email',

  phone = 'shipment_info.phone',
  postalCode = 'shipment_info.postal',
  state = 'shipment_info.state',
  city = 'shipment_info.city',
  street1 = 'shipment_info.street',
  street2 = 'shipment_info.neighborhood',
}

export const DECIMAL_DIGITS_ALLOWED: number = 2;
export const DECIMAL_POINT_CHAR: string = '.';
export const ONE_DECIMAL_POINT: number = 1;
export const SEPARATOR: string = '';
